import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const NotificationBell = () => {
  const nav = useNavigate();
  const [d, setD] = useState({ items: [], unread: 0 });
  const load = useCallback(() => api.get("/notifications").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const open = async (n) => { await api.post(`/notifications/${n.id}/read`).catch(() => {}); load(); if (n.link) nav(n.link); };
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <button className="relative rounded-control p-2 text-slate-500 hover:bg-slate-100 hover:text-ink" aria-label="Notifiche" data-testid="notifications-bell">
          <Bell className="h-[18px] w-[18px]" strokeWidth={1.75} />
          {d.unread > 0 && <span className="absolute right-1 top-1 min-w-4 rounded-full bg-brand-500 px-1 text-[10px] font-bold leading-4 text-white" data-testid="notifications-unread">{d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[calc(100vw-1rem)] max-w-sm p-0" data-testid="notifications-panel">
        <div className="flex items-center justify-between border-b border-line px-4 py-2.5"><p className="text-sm font-semibold text-ink">Notifiche</p>
          {d.unread > 0 && <button className="text-xs font-semibold text-brand-700" onClick={() => api.post("/notifications/read-all").then(load)} data-testid="notifications-read-all">Segna tutte come lette</button>}</div>
        <ul className="max-h-96 overflow-y-auto">
          {d.items.length === 0 && <li className="px-4 py-6 text-center text-sm text-slate-500">Nessuna notifica.</li>}
          {d.items.map((n) => (
            <li key={n.id}><button onClick={() => open(n)} className={`w-full px-4 py-2.5 text-left hover:bg-slate-50 ${n.read_at ? "" : "bg-brand-50/40"}`} data-testid={`notification-${n.id}`}>
              <p className={`text-sm ${n.read_at ? "text-slate-600" : "font-semibold text-ink"}`}>{n.title}</p><p className="text-[11px] text-slate-400">{fmtDateTime(n.created_at)}</p></button></li>))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
